
import React, { Component } from 'react';

import UrlServer from "configs/UrlServer"
import { APIPost, APIGet } from "services/APIRequest"
import * as Alert from "alertService"
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import Button from "components/CustomButtons/Button"

//Component==================
import Chart1 from "./chart1"
import Chart1L2 from "./chart1L2"
import Chart1L3 from "./chart1L3"
import Chart2 from "./chart2"

//ICON==================
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
class Chart extends Component {
	constructor() {
		super();
		this.state = {
			level_chart_1: 1,
			cerrent_quarter: null,
			dealer_code_list: null,
			cerrent_area: null,
			chart_1_allready: false,
			chart_1_data: {
				qtr2: null,
				qtr3: null,
				qtr4: null,
				qtr1: null,
				qtr2_n: null,
				qtr3_n: null,
				qtr4_n: null,
				qtr1_n: null,
			}
		}
	}
	componentDidMount() {
		Alert.Loading(true)
		const dataToSend = {
			// quarter: this.state.quarter,
			// data_year: this.state.data_year,
		}
		// APIPost(UrlServer.URL_GET_GENERATEREPORTS_GET_CALL_CLEAN_RAW_REPORT_GENERATE, dataToSend, ({ datas }) => {
		this.getDataAVGAll()
		// })
	}
	getDataAVGAll = () => {
		APIPost(UrlServer.URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD3_OS1, {}, ({ datas }) => {
			this.setState({
				chart_1_allready: true,
				chart_1_data: datas
			}, () => {
				Alert.LoadingClose()
			})
		})
	}
	callbackChangelevelChart1 = (data) => {
		if (this.state.level_chart_1 == 1) {
			var _cerrent_quarter = 2
			switch (data.selected) {
				case 0:
					_cerrent_quarter = 2
					break;
				case 1:
					_cerrent_quarter = 3
					break;
				case 2:
					_cerrent_quarter = 4
					break;
				case 3:
					_cerrent_quarter = 1
					break;
			}
			this.setState({
				level_chart_1: data.level,
				cerrent_quarter: _cerrent_quarter
			})
		} else if (this.state.level_chart_1 == 2) {
			this.setState({
				level_chart_1: data.level,
				cerrent_area: data.data.name,
				dealer_code_list: data.data.dealer_code_list
			})
		}

	}
	goback() {
		this.setState({
			level_chart_1: this.state.level_chart_1 - 1
		})
	}
	render() {

		return (
			<div className={"card-space"}>
				<hr className="hr-s-m-0" />
				<GridContainer justify="center">
					<GridItem xs={12}>
						<center>
							<h3><b>AVG Nationwide</b></h3>
						</center>
					</GridItem>
					<GridItem xs={12}>
						{
							(this.state.chart_1_allready && this.state.level_chart_1 == 1) ?
								<GridContainer justify="center">
									<GridItem xs={12}>
										<small className="txt-c-dorg2"><i>* สามารถกดที่ Chart เพื่อเข้าไปดูข้อมูลต่อได้</i></small>
									</GridItem>
									<GridItem xs={12}>
										<Chart1 chart_1_data={this.state.chart_1_data} callbackChangelevel={this.callbackChangelevelChart1} />
									</GridItem>
								</GridContainer>
								: (this.state.level_chart_1 == 2) ?
									<GridContainer justify="center">
										<GridItem xs={12}>
											<Button
												size="sm"
												round
												variant="outlined"
												// color="secondary"
												onClick={e => this.goback()}
											>
												<ArrowBackIcon />
												ย้อนกลับ
											</Button>{" "}
											<small className="txt-c-dorg2"><i>* สามารถกดที่ Chart เพื่อเข้าไปดูข้อมูลต่อได้</i></small>
										</GridItem>
										<GridItem xs={12}>
											<Chart1L2 cerrent_quarter={this.state.cerrent_quarter} callbackChangelevel={this.callbackChangelevelChart1} />
										</GridItem>
									</GridContainer>
									: (this.state.level_chart_1 == 3) ?
										<GridContainer justify="center">
											<GridItem xs={12}>
												<Button
													size="sm"
													round
													variant="outlined"
													color="secondary"
													onClick={e => this.goback()}
												>
													<ArrowBackIcon />
													ย้อนกลับ
												</Button>
											</GridItem>
											<GridItem xs={12}>
												<Chart1L3 cerrent_quarter={this.state.cerrent_quarter} cerrent_area={this.state.cerrent_area} dealer_code_list={this.state.dealer_code_list} callbackChangelevel={this.callbackChangelevelChart1} />
											</GridItem>
										</GridContainer>
										: null
						}
					</GridItem>
					<GridItem xs={12} >
						<hr className="hr-s" />
					</GridItem>
					<GridItem xs={12} >
						<Chart2 level_chart_1={this.state.level_chart_1} cerrent_quarter={this.state.cerrent_quarter} cerrent_area={this.state.cerrent_area} />
					</GridItem>
				</GridContainer>
			</div>
		);
	}
}

export default Chart;